import React from 'react';
// import { NEXT_PUBLIC_CART_DATA } from '@/store/constants';
import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';
// import { CartRootObject } from 'types/Order/index.d';

const initialWooContext = {
    loading: false,
    setLoading: (value: boolean) => {},
    cartSuccess: false,
    setCartSuccess: (value: boolean) => {},
    cart: null,
    setCart: (value: any) => {},
    shipping: null,
    setShipping: (value: any) => {},
}
 // Initialize Menu context object.
export const WooContext = createContext(initialWooContext);

/**
 * Export useContext Hook.
 *
 * @return {Function} Woocommerce Context
 */
export function useWoocommerceContext() {
    return useContext(WooContext);
}
type WoocommerceProviderProps = {
    children: React.ReactNode;
    value: any;
};

export default function WoocomerceProvider(
    props: WoocommerceProviderProps,
): JSX.Element {
    const { children } = props;
    const [cartSuccess, setCartSuccess] = useState(false);
    const [shipping, setShipping] = useState(null);

    const [cart, setCart] = useState(null);
    const [loading, setLoading] = useState(false);

   
    return (
        <WooContext.Provider
            value={{
                loading,
                setLoading,
                cartSuccess,
                setCartSuccess,
                cart,
                setCart,
                shipping,
                setShipping,
            }}
        >
            {children}
        </WooContext.Provider>
    );
}

WoocomerceProvider.propTypes = {
    children: PropTypes.node,
    value: PropTypes.any,
};
